
export default {
  name: 'ClassBox',
  props: {
    hasImage: {
      type: Boolean,
      default: true,
    },
    isClosed: {
      type: Boolean,
      default: false,
    },
    classe: {
      type: [Object, Array],
      default() {},
    },
  },
  data() {
    return {
      linkedClasses: [
        {
          id: '04031985-2e62-4bbc-a75f-600b43daf869',
          image:
            'https://app.mege.com.br/products/d177ccbfb0200ecfe467553932d8e068.webp',
          description: null,
          name: 'TESTE 2',
        },
      ],
    }
  },
  computed: {
    isPendingPayment() {
      return this.classe.subscription?.status === 'inadimplente'
    },
  },
}
